'use client';
import { forwardRef } from 'react';
import Typography from '../typography/index.mjs';
import { jsx } from 'react/jsx-runtime';

var Label = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    Typography,
    {
      variant: "label1_normal",
      weight: "bold",
      color: "palette.label.alternative",
      as: "label",
      ref,
      ...props
    }
  );
});
Label.displayName = "Label";
var label_default = Label;

export { label_default as default };
